export const YellowHeader4 = () => {
  return (
    <section className="yellowHeader">
      <h2>Ważne!</h2>
      <p>Podaj adres oraz termin odbioru rzeczy.</p>
    </section>
  );
};
